
import { Link } from "react-scroll"
import '../css/premios.css'
import ButtonUp from "./ButtonUp"



const Exposiciones = () => {
  return (
    <div className='intro' style={{ width: '85%' }}>
      <ButtonUp/>
      <h2>Exposiciones</h2>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px', flexWrap: 'wrap' }}>
        <div className="linkPremios" ><Link className="linkTexto" to="2024" smooth={true} offset={-75} duration={500}>2024</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2023" smooth={true} offset={-75} duration={500}>2023</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2022" smooth={true} offset={-75} duration={500}>2022</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2019" smooth={true} offset={-75} duration={500}>2019</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2018" smooth={true} offset={-75} duration={500}>2018</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2017" smooth={true} offset={-75} duration={500}>2017</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2016" smooth={true} offset={-75} duration={500}>2016</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2015" smooth={true} offset={-75} duration={500}>2015</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2014" smooth={true} offset={-75} duration={500}>2014</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2013" smooth={true} offset={-75} duration={500}>2013</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2012" smooth={true} offset={-75} duration={500}>2012</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2011" smooth={true} offset={-75} duration={500}>2011</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2010" smooth={true} offset={-75} duration={500}>2010</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2009" smooth={true} offset={-75} duration={500}>2009</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2008" smooth={true} offset={-75} duration={500}>2008</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2007" smooth={true} offset={-75} duration={500}>2007</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2006" smooth={true} offset={-75} duration={500}>2006</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2005" smooth={true} offset={-75} duration={500}>2005</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2004" smooth={true} offset={-75} duration={500}>2004</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2003" smooth={true} offset={-75} duration={500}>2003</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="2002" smooth={true} offset={-75} duration={500}>2002</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="1998" smooth={true} offset={-75} duration={500}>1998</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="1997" smooth={true} offset={-75} duration={500}>1997</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="1996" smooth={true} offset={-75} duration={500}>1996</Link></div>
        <div className="linkPremios"><Link className="linkTexto" to="1995" smooth={true} offset={-75} duration={500}>1995</Link></div>



      </div>

      <div className="divPremios" id="2024">
        <h3>2024</h3>
        <ul>
          <li>Octubre, participación de la “V Muestra del Grabado”, con una obra presencial y con una obra de forma virtual, organizado por el Centro Cultural Esquel Melipal, provincia de Chubut, Argentina.</li>
          <li>Octubre, participación en la convocatoria de Poesía Visual, Museo de Arte Cañadense.</li>
          <li>Octubre, participación en la trienal internacional de grafica de arte de Bitola, Macedonia del Norte.</li>
          <li>Septiembre, Participación de la Exposición “Fiesta de la Mercé Barcelona 2024, Cenro Cultural Montjuic.
            Barcelona, España https://www.facebook.com/WentworthNorton/videos/839566847957259
          </li>
          <li>Julio, Bienal Internacional de Artes en Miniatura Timisoara 2024 “Micromundos”,
            https://arte-fact.uvt.ro/project/biamt-2024-micromundos/
          </li>
          <li>Mayo, “participación de la convocatoria “Mini Works”, Sergi exhibiciones, Universidad de Balikesir, Facultad de Bellas Artes, Turquía</li>
          <li>Mayo, 1ª BIENAL INTERNACIONAL DE TEXTO ARTE "100 DESEOS DE PRIMAVERA PARA TI MISMO" https://youtu.be/CunlA_35vuQ?si=vcQcOTnwC3ROWRgi</li>
          <li>Abril - Junio, participación de la exposición “Minima”, Arte Contemporáneo pequeño formato, en Pedro de Mendoza 650 CABA.</li>
          <li>Marzo - Abril Exposición internacional de grabado pequeño "Maxnifier IV" Into Nature 2024 Comisariado por el estudio ml3print, Tailandia</li>
        </ul>
      </div>

      <div className="divPremios" id="2023">
        <h3>2023</h3>
        <ul>
          <li>Diciembre,  1ª Exposición Mundial de artes Visuales, “Raíces de la Tierra”, Museo Teófilo Reyes, México</li>
          <li>Noviembre, https://magmasanat.com/index.php/1uluslararasi-magma-sanat-acik-cagrili-karma-sergisi/
            1ª Exposición Colectiva Online Convocatoria Abierta Internacional “Magma Art”
          </li>
          <li>Octubre, exposición virtual ¿Qué tenés grabado?, convocatoria Museo Mínimo http://www.museominimo.gonzalezperrin.com.ar/</li>
          <li>Octubre, IVª Muestra Virtual Internacional de Grabado - Esquel 2023 Argentina https://www.esquel.gov.ar/grabado-esquel2023</li>
          <li>Septiembre, Poesia Visual, Libro Objeto Colaborativo, 2023, Convocatoria Rosa Gravino https://drive.google.com/file/d/1bLYY0EoL7PuUz5rgE4ZDN7eoy4AXagLf/view?usp=drivesdk</li>
          <li>Abril, participación en la exposición “46 artistas de Austria y Argentina”, en el Atelier Controsegno, Via Napoli 201, Pozzuoli, Napoles</li>
          <li>Diciembre 2022-Enero 2023, “Vll Litografía Argentina Contemporánea”, Galería – Centro de Edición, Rosales 4027, Villa Linch, Provincia de Bs. As., Argentina.</li>
        </ul>
      </div>

      <div className="divPremios" id="2022">
        <h3>2022</h3>
        <ul>
          <li>Septiembre, participación en “Riverarte lV, en el Museo River Plate, Av. Pres. Figueroa Alcorta 7509, CABA.</li>
          <li>Septiembre, participación en 27 Salón Primavera de San Fernando, sección grabado, Bahía Punta Chica,  Ricardo Rojas y el rio, San Fernando Prov. Bs. As.</li>
          <li>Junio, Julio, Agosto “Líneas de vida”, exposición en Museo Carnaccini, Pueyrredón 2729, villa Ballester, provincia de Buenos Aires, Argentina.</li>
          <li>Junio, Julio, Agosto “Líneas de vida”, exposición en las Galerías Schloss Bogenšperk Castle, Šmartno pri Litiji, Eslovenia.</li>
        </ul>
      </div>
      <div className="divPremios" id="2019">
        <h3>2019</h3>
        <ul>
          <li>Noviembre, V Salón de grabado “Zulema Petruschansky”, Asociación Estimulo de bellas Arte, galería Ernesto de la Carcova, Av. Córdoba 701 CABA</li>
          <li>Octubre, 8° Salón Pequeño formato, Museo Casa Carnaccini, Villa Ballester, Prov. Bs. As.</li>
          <li>Julio, exposición Colectiva “Piel de papel”, en el Museo MuBal, Alvear 125 Lincoln Provincia de Buenos Aires, Argentina.</li>
          <li>Abril, participación en la exposición de Mujeres en el Grabado, en Pompano Beach Cultural Center Gallery, Miami EEUU.</li>
        </ul>
      </div>
      <div className="divPremios" id="2018">
        <h3>2018</h3>
        <ul>
          <li>Julio, exposición colectiva “Constelaciongráfica”, Delegación Florida, Vergara 2382, Florida, Vicente López, Provincia de Bs. As., Argentina</li>
          <li>Junio, exposición colectiva “Constelaciones Graficas”, en Fundacruz, Casa de la Cultura, Gobernador Lista 60, Río Gallegos, Argentina</li>
          <li>Marzo, participación en “Lunática”, Arte&Turf, en el Hipódromo de Palermo, Av. del Libertador 4101, CABA</li>
          <li>Enero - Febrero, “Women Printmakers”, exposición colectiva en la embajada de Argentina en Washington., 1600 New Hampshire Ave, NW; Washington DC, EEUU.</li>
        </ul>
      </div>
      <div className="divPremios" id="2017">
        <h3>2017</h3>
        <ul>
          <li>Diciembre, “Women Printmakers”, exposición colectiva en la embajada de Argentina en Washington., 1600 New Hampshire Ave, NW; Washington DC, EEUU.</li>
          <li>Septiembre, 6º Salón de Pequeño Formato, Museo Casa Carnaccini, Calle 110 (Pueyrredón) N 2720, Villa Ballester, Prov. De Bs. As. Argentina.</li>
        </ul>
      </div>
      <div className="divPremios" id="2016">
        <h3>2016</h3>
        <ul>
          <li>Diciembre, participación en la Muestra de Artes Plásticas Helios Gagliardi”, organizado por la S.A.A.P, Sociedad Argentina de Artistas Plásticos, en el Museo Histórico Municipal de Ituzaingo.</li>
          <li>Marzo, participación en “Latinamerican Women Printing, en Art&Desingn Gallery 8650 Biscayne Bvld 2 Miami, EEUU.</li>
        </ul>
      </div>
      <div className="divPremios" id="2015">
        <h3>2015</h3>
        <ul>
          <li>Noviembre, “Mujeres que Imprimen” “Printing Women”, en Art&Desingn Gallery 8650 Biscayne Bvld 2 Miami, EEUU.</li>
          <li>Septiembre, exposición “Stamps ll” Solange Guez, Arte Contemporáneo, Zapiola 2196- CABA organizado por el centro de Edición.</li>
          <li>Octubre, V Salón de Dibujo, Premio Marcelo Mayorga, Asociación Estimulo de Bellas Artes, Av. Córdoba 701 CABA, </li>
          <li>Octubre, Proyecto grupal de Artistas contemporáneos, en el marco del lX Festival Cervantino, Museo de Bellas Artes López Claro, Azul, Prov. De Bs. As. Argentina.</li>
          <li>Mayo, Semana de la gráfica Patagonia 2015, Bosque Neón , Mitre 415-Loc. 19- Bariloche, Argentina</li>
          <li>Marzo “Mujeres+arte”, ciclo anual de Arte Plástico, UNLaM, Universidad Nacional de la Matanza, Florencio Varela 1903, San Justo, Prov. De Bs. As.</li>
        </ul>
      </div>
      <div className="divPremios" id="2014">
        <h3>2014</h3>
        <ul>
          <li>Julio Xlll Salón de Pequeño Formato, Médano – Multiespacio de Artes del Norte, Calle 11 Nº 1185, General Pico, La Pampa., Argentina</li>
          <li>Abril, participación en la Feria,”Affirdable Art Fair”, Metropolitan Pavilion, con el Centro de Edicion de Buenos Aires, en la ciudad de  Nueva York EEUU.</li>
        </ul>
      </div>
      <div className="divPremios" id="2013">
        <h3>2013</h3>
        <ul>
          <li>Noviembre, participación en la exposición “Riverarte, en el Museo del Club Atlético River Plate, Av. Pres. Figueroa Alcorta 7509, CABA.</li>
          <li>Agosto, Exposición “Artistas Premiados en el Salón de la S.A.A.P, en el consejo deliberante de la Municipalidad de Vicente López, Av. Maipú 2502, Olivos Prov. De Bs. As.</li>
          <li>Agosto,  2ª Salón de Dibujo de la Asociación Estimulo de Bellas Artes, Av. Córdoba 701 CABA.</li>
          <li>Participación en la muestra itinerante “Estampillas, organizada por el Centro de Edición :*Marzo: Lauderhill Arts Center – Miami. EEUU. *Junio: Centro de Edición Taller/galería, Buenos Aires, Argentina. </li>
          <li>Septiembre: Centro Cultural Rada Tilly- Chubut, Argentina. * Octubre: La Lucinda- Santa Cruz, Argentina</li>
          <li>Julio, Seleccionada en el Salón de Artes Visuales de la Provincia de La Pampa – Dibujo, Museo provincial de Artes, 9 de Julio y Villegas, La Pampa, Argentina. </li>
          <li>Abril, Exposición “Libros de artistas de Edición”, convocado por el Centro de Edición de Buenos Aires, en las Salas de Exposiciones de San Martin de los Andes, Cap. Drury 665, San Martin de los Andes, Argentina</li>
          <li>Febrero, participación en la muestra “Anual de grafica Contemporánea 2013”, en el Museo de Arte Contemporáneo Mac, Prov. de Salta. Argentina</li>
          <li>Enero, Participación de la exposición “Diversidad”, en el Hotel Conrad Punta del Este Resort& Casino, Playa Mansa, parada 4, Punta del Este, Uruguay</li>
        </ul>
      </div>
      <div className="divPremios" id="2012">
        <h3>2012</h3>
        <ul>
          <li>Septiembre, Edición Argentina Vol. II, presentación de libros de artistas en el Museo Municipal de Arte Puerto Madryn, Chubut. ARGENTINA</li>
          <li>Septiembre, XlX Salón de Artes Plásticas, de la SAAP, filial Morón, exposición en el Consejo Profesional de Agrimensura, Pellegrini 755 , Morón, prov. de Bs. As..</li>
          <li>Agosto, Participación en la 1ª Bienal de Dibujo, Premio Lino Enea Spilimbergo, SAAP 2012, Viam onte 458, CABA</li>
          <li>Agosto, Exhibición  “El Gran Balance”, durante la Conferencia Internacional Gran Balance, Hotel Bauen Suites, Buenos Aires, Argentina. </li>
          <li>Mayo, Arte Clásica Contemporánea, 9ª Feria de Arte 2012, Galería Edgar Kramer Fine Art, Pabellon 5, Centro Costa Salguero</li>
        </ul>
      </div>
      <div className="divPremios" id="2011">
        <h3>2011</h3>
        <ul>
          <li>Septiembre, participación en la “Muestra itinerante BAI 2010,organizado por la universidad Nacional de la Matanza, en el Honorable Senado de la Nación, Museo Parlamentario, Senador Faustino Sarmiento, Hipólito Yrigoyen 1708, Planta baja, CABA</li>
          <li>Octubre, participación en el Salón Multidisciplinario, organizado por “Espacio 10 Arte” Fine Art Gallery</li>
          <li>Julio, participación en la feria “Arteclasica11”, 8ª Feria de arte moderno y contemporáneo, organizada por Nazli Kalayci Art Dealer, Pabellón 1 y 2 Costa Salguero Stand A5</li>
          <li>Julio – Agosto, participación en el  76 Salón de Otoño 2011, “Homenaje a Enrique Policastro,organizado por la Asociación Argentina de Artistas Plásticos, en la Fundación Rómulo Raggio, Gaspar del Campo 861, Vicente López.</li>
          <li>Abril – Mayo, exposición colectiva en “Arte en las Vidrieras”, Galería Naonis, Belgrano 70, Ramos Mejía, Prov. De Bs. As.</li>
          <li>Marzo, Exposición “Misterios y Figuras”, en el Museo Municipal de Bellas Artes, Felix de Amador, 9 de Julio 863, Lujan Prv. De Bs. As.</li>
        </ul>
      </div>

      <div className="divPremios" id="2010">
        <h3>2010</h3>
        <ul>
          <li>Noviembre, participación en la muestra colectiva, de BAI2010 , Concurso Prebienal de arte Integral, Universidad Nacional de La Matanza, Florencio Varela 1903, San Justo, Prv. De Bs. As., Argentina.</li>
          <li>Septiembre, participación en la Feria de Arte “Expotrastiendas 2010”, organizado por “Desde la Plastica”, en Av. Santa Fe 4201, Pabellon Ocre, La Rural Stand 45.</li>
          <li>Exposición individual en “La Cupula”, Secretaria de Turismo de Lujan, organizado por la S.A.A.P.</li>
          <li>Julio – Agosto, participación en el  LXXV Salón de Otoño 2010,organizado por la Asociación Argentina de Artistas Plásticos, en la Fundación Rómulo Raggio, Gaspar del Campo 861, Vicente López.</li>
          <li>Julio, participación en la feria de arte “Arteclasica10”,  Pabellón 1 y 2 Costa Salguero, Stand F2/ F4</li>
          <li>Junio, participación en la segunda muestra “85 años en el Arte”, de la Sociedad Argentina de Artistas Plásticos, S.A.A.P., Viamonte 458 CABA.</li>
          <li>Enero, participante en la exposición “Artistas a la Carta”, organizada por Nazli Kalayci Art Dealer, presentando la muestra “Figuras y Abstracción, al fin del Mundo”, en el Museo Marítimo de Ushuaia, Prov. De Tierra del Fuego, Argentina.</li>
        </ul>
      </div>

      <div className="divPremios" id="2009">
        <h3>2009</h3>
        <ul>
          <li>Octubre, exposición en el Patio de Arte Grecorromano, parte del “Ciclo Anula de Exposiciones de Artes Plásticas 2009, en la UNLaM, Universidad de la Matanza.</li>
          <li>Octubre, muestra colectiva en la Jornada: Inclusión Social a través del Arte, Universidad de la Matanza, Florencio Varela 1903, San Justo, Prov. De Bs. As.</li>
          <li>Octubre, participación en “Artemultiplo”, organizado por “desde la Pastica, espacio de arte”, Stand 15, en Tattersall- Jockey Club, Hipódromo de San Isidro.</li>
          <li>Mayo, Exposición colectiva “Luz y Vida”, Ciclo Cultural 2009, en la Bolsa de Comercio de Buenos Aires, 25 de Mayo 359, hall central, CABA</li>
          <li>Abril, Exposición de dibujos, en el “Patio grecorromano” de la UNLaM, formo parte del “Ciclo Anual de Exposiciones de Artes Plástico 2009”, organizado por la Universidad de La Matanza</li>
          <li>Marzo, Exposición de dibujos, en el “Patio grecorromano” de la UNLaM, Muestra denominada “Misterios y Realidades”, en la Universidad de La Matanza.</li>
          <li>Marzo, Muestra de Arte, en la Escuela Superior técnica Gral Manuel N. Savio, Av. Cabildo 15 CABA</li>
        </ul>
      </div>

      <div className="divPremios" id="2008">
        <h3>2008</h3>
        <ul>
          <li>Diciembre, participación con dibujos en “Artenlance”, en el Museo Metropolitano, Castex 3217 CABA.</li>
          <li>Noviembre, participación en el lll Salón de Dibujo “Raúl Alonso”, organizado por “Artistas Visuales de Vicente López, en el Museo de la Fundación Rómulo Raggio, Gaspar Campos 861, Vicente López, Prov. De Bs. As. Argentina</li>
          <li>Agosto, participación en Artemultiplo, a través de Desde la Plástica, espacio de arte, en el Palais de Glace, Posadas 1752 CABA. Stand 28 y 29</li>
          <li>Julio, participación en el Vll Salón de Pequeño Formato, organizado por la Municipalidad de Gral. Pico, Prov. De Bs. As.</li>
          <li>Julio, Participación en Arteclasica 08, 5ª Feria de Arte Moderno y Contemporáneo, Stand F02, “Desde la Plástica, espacio de arte”</li>
        </ul>
      </div>

      <div className="divPremios" id="2007">
        <h3>2007</h3>
        <ul>
          <li>Diciembre, Feria de Arte, organizada por “Desde la Plástica, espacio de arte”, Gascón 1159 CABA</li>
          <li>Septiembre, seleccionada en el 4º Concurso de Pintura, Fundacion travesia 2007</li>
          <li>Febrero – Marzo, Exposición colectiva, en  “Casa de San Luis”, Azcuénaga 1083 CABA</li>
          <li>Febrero, Exposición colectiva, en  “Universidad Católica de Salta”, Paseo Colón 533 CABA</li>
        </ul>
      </div>

      <div className="divPremios" id="2006">
        <h3>2006</h3>
        <ul>
          <li>Noviembre – Diciembre, “Muestra de fin de año”, Exposición colectiva, Palacio de las Artes, Zapiola 2196 CABA.</li>
          <li>Noviembre, Exposición colectiva, organizada por “Desde la Plástica, espacio de arte, Gascón 1159, Palermo CABA</li>
          <li>Noviembre, Seleccionada en la exposición “Arte Contemporáneo”, organizada por Loft Espacio Alfa, casa de Santiago del Estero. Argentina.</li>
          <li>Septiembre, Seleccionada en el Salón “Arte Hoy”, organizado por galería Lof Espacio Alfa, Fine Arts.</li>
          <li>Julio, Exposición colectiva, organizada por “Arte Argentino Hoy, en la Sala de Arte Schering Argentina, Monroe 1378 CABA.</li>
          <li>Monroe 1378 CABA.
            *Junio, Exposición colectiva, “Muestra de Arte Latinoamericano, organizado por “Desde la Plástica, espacio de arte. Pasaje La Piedad 18 CABA
          </li>
          <li>Monroe 1378 CABA.
            *Junio, Exposición colectiva, “Muestra de Arte Latinoamericano, organizado por “Desde la Plástica, espacio de arte. Pasaje La Piedad 18 CABA
          </li>
        </ul>
      </div>
      <div className="divPremios" id="2005">
        <h3>2005</h3>
        <ul>
          <li>Octubre, seleccionada en el 2ª Concurso de Pintura, “Fundación Travesía”</li>
          <li>Octubre seleccionada para exponer en el Salón de Artes Plásticas “Fuerza Empresaria 2005”, Hall central de la Bolsa de Comercio de Bs. As.</li>
          <li>Octubre, Exposición de Arte colectiva, “75º Aniversario Escuela Superior Técnica” “General de división Manuel Nicolás Savio”, Av. Cabildo 15 – Planta Baja. CABA.</li>
          <li>Septiembre, Muestra de Artes Plásticas colectiva, en Colegios Consejos profesionales , zona oeste CPO, Dr Eizaguirre 1943, San Justo, Prov. Bs. As., Argentina.</li>
          <li>Septiembre-Octubre, Muestra grupal de Arte, Anexo Galería de Arte, El Figon-fun restobar. Jacarandaes y los robles, Ciudad Jardín, el Palomar. Prov. De Bs. As. Argentina.</li>
          <li>Julio, Exposición de Dibujo  en “desde la Plástica”, espacio de arte, Pasaje de la Piedad 18, CABA.</li>
          <li>Junio-Julio, Exposición colectiva  “Artestimulo 2005”, organizado por la Sociedad Estimulo de Bellas Artes de Ramos Mejía, Castelli 129, Ramos Mejía, Prov. De Bs. As. Argentina</li>
          <li>Mayo-Junio, Exposición  colectiva “Homenaje a Antonio Berni”, organizado por la Sociedad Estimulo de Bellas Artes de Ramos Mejía, Castelli 129, Ramos Mejía, Prov. De Bs. As. Argentina</li>
        </ul>
      </div>

      <div className="divPremios" id="2004">
        <h3>2004</h3>
        <ul>
          <li>Mayo, Exposición Unipersonal, “Retrospectiva”, en la Sociedad Estimulo de Bellas Artes de Ramos Mejía, Castelli 129, Ramos Mejía, prov. De Bs. As.</li>
          <li>Noviembre – diciembre, Exposición colectiva taller Jorge Meijide, en la agencia periodística-Cid-diario del viajero, Av. De Mayo 666</li>
        </ul>
      </div>

      <div className="divPremios" id="2003">
        <h3>2003</h3>
        <ul>
          <li>Noviembre, Exposición  colectiva taller Jorge Meijide, en la agencia periodística-Cid-diario del viajero, Av. De Mayo 666</li>
          <li>Agosto, 1ª Salón de Grabado y Escultura, Asociación Estimulo de Bellas Artes, Galería Ernesto de la Carcova, Av. Córdoba 701, CABA.</li>
        </ul>
      </div>

      <div className="divPremios" id="2002">
        <h3>2002</h3>
        <ul>
          <li>Marzo, muestra de los tallere002s de Artes Visuales del Centro Cultural Recoleta, Espacio Escalera, Salas 12, 13, 14,15 Pasillo de PB y PA, CABA.</li>
        </ul>
      </div>

      <div className="divPremios" id="1998">
        <h3>1998</h3>
        <ul>
          <li>Abril, 2ª Salón anual de Pintura Figurativa, organizado por Encuentr’arte – Casa de arte, Av. Balbín 2580 CABA.</li>
          <li>Marzo, Salón anual de Pintura Abstracta, organizado por Encuentr’arte – Casa de arte, Av. Balbín 2580 CABA.</li>
        </ul>
      </div>

      <div className="divPremios" id="1997">
        <h3>1997</h3>
        <ul>
          <li>Diciembre 1997 a abril 1998, exposición colectiva en el hotel “Playas en Pinamar, organizado por Cre-ate, Dir. Rita Liliana Pulella, Alfredo Palacios 138 Ramos Mejía, Provincia de buenos Aires. Argentina</li>
          <li>Diciembre, exposición, Salón Fin de Año Encuentr’arte, Casa de Arte. Av. Balbin 25 80 – CABA</li>
          <li>Septiembre,, seleccionada en el 4º Salón 1997, pintura, Cre-Arte, Alfredo Palacios 138, Ramos Mejía</li>
          <li>Septiembre, exposición colectiva,  1 Salón “Encuentrazoz” de Dibujo y Pintura, categoría dibujo, Encuentr’arte, Casa de Arte. Av. Balbín 25 80 – CABA</li>
          <li>Julio, Seleccionada en el Salón Gala 1997, Gala, Centro de arte.</li>
          <li>Agosto, exposición colectiva, Encuentr’arte, Concurso de pintura “Encuentr’arte 97”, Casa de Arte. Av. Balbín 25 80 – CABA</li>
          <li>Agosto, participación en el evento “Un voto por la cultura”, organizado por la galería Daitter Hajj, Maria K restaurant.</li>
        </ul>
      </div>

      <div className="divPremios" id="1996">
        <h3>1996</h3>
        <ul>
          <li>Diciembre, Exposición Colectiva del taller de Arte del Profesor Marcelo Adrián Pérez, en la Biblioteca Pública  Almafuerte, de la Escuela Nª 24 Patricias Argentinas, Pueyrredón 911, Ramos Mejía, Prov. BS. AS. Argentina</li>
        </ul>
      </div>

      <div className="divPremios" id="1995">
        <h3>1995</h3>
        <ul>
          <li>Diciembre, Exposición Colectiva del taller de Arte del Profesor Marcelo Adrián Pérez, en la Biblioteca Pública  Almafuerte, de la Escuela Nª 24 Patricias Argentinas, Pueyrredón 911, Ramos Mejía, Prov. BS. AS. Argentina</li>
        </ul>
      </div>

    </div>

  )
}

export default Exposiciones